import React, { useState, useEffect, useRef } from "react";
import {
  Header,
  Container,
  Table,
  Button,
  Icon,
  Input,
} from "semantic-ui-react";
import { PendingRow } from "components/Admin/PendingRow";
import { getTargetList, updateTarget } from "services/developer";
const Target = ({ appDetail, handleMessage, editTagRef }) => {
  const [loaded, setLoaded] = useState(false);
  const [formDataList, setFormDataList] = useState([
    { stage: "dev", value: "", isEdit: false },
    { stage: "uat", value: "", isEdit: false },
    { stage: "prod", value: "", isEdit: false },
  ]);
  const targetInfo = useRef({});
  useEffect(() => {
    (async () => {
      if (appDetail) {
        if (appDetail.AppId) {
          if (editTagRef.current) return;
          const targets = await getTargetList();
          initTargetInfo(targets);
        } else {
          resetTargetInfo();
        }
        setLoaded(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appDetail]);

  const initTargetInfo = (targets) => {
    const filteredTarget = targets.filter(
      (target) => target.AppId === appDetail.AppId
    );
    let obj = {};
    filteredTarget.forEach((target) => {
      obj[target.Environment] = target.Target;
    });
    targetInfo.current = obj;
    const data = formDataList.map((formData) => {
      formData.value = targetInfo.current[formData.stage] || "";
      return formData;
    });
    setFormDataList(data);
  };

  const resetTargetInfo = () => {
    targetInfo.current = {};
    setFormDataList([
      { stage: "dev", value: "", isEdit: false },
      { stage: "uat", value: "", isEdit: false },
      { stage: "prod", value: "", isEdit: false },
    ]);
  };

  const onUpdateTarget = (index) => {
    const newFormDataList = [...formDataList];
    newFormDataList[index].isEdit = true;
    setFormDataList(newFormDataList);
  };

  const onChangeTarget = (index, value) => {
    const newFormDataList = [...formDataList];
    newFormDataList[index].value = value;
    setFormDataList(newFormDataList);
  };

  const onCancelSave = (index) => {
    const newFormDataList = [...formDataList];
    newFormDataList[index].isEdit = false;
    newFormDataList[index].value =
      targetInfo.current[newFormDataList[index].stage];
    setFormDataList(newFormDataList);
  };

  const onSaveTarget = async (index) => {
    setLoaded(false);
    const formData = formDataList[index];
    const params = {
      UserName: appDetail.UserName,
      AppId: appDetail.AppId,
      Environment: formData.stage,
      Target: formData.value,
    };
    const res = await updateTarget(params);
    if (res.success) {
      const newFormDataList = [...formDataList];
      newFormDataList[index].isEdit = false;
      setFormDataList(newFormDataList);
      targetInfo.current[formData.stage] = formData.value;
    }
    handleMessage({ success: res.success, operation: "updateTarget", content: res.message });
    setLoaded(true);
  };

  const tableRows = formDataList.map((item, index) => {
    if (!loaded) {
      return <PendingRow columnCount={2} key={index} />;
    }
    return (
      <Table.Row key={item.stage}>
        <Table.Cell style={{ textTransform: "uppercase" }}>
          {item.stage}
        </Table.Cell>
        <Table.Cell>
          {item.isEdit ? (
            <>
              <Input
                type="text"
                style={{ marginRight: "5px" }}
                value={item.value}
                focus
                onChange={(_, { value }) => onChangeTarget(index, value)}
              />
              <Button
                icon
                size="mini"
                compact
                className="check-icon-button"
                onClick={() => onSaveTarget(index)}
              >
                <Icon name="check" />
              </Button>
              <Button
                icon
                size="mini"
                compact
                onClick={() => onCancelSave(index)}
              >
                <Icon name="delete" />
              </Button>
            </>
          ) : (
            <>
              <span style={{ marginRight: "5px" }}>{item.value}</span>
              <Button
                disabled={!appDetail?.AppId}
                icon
                size="mini"
                compact
                onClick={() => onUpdateTarget(index)}
              >
                <Icon name="pencil" />
              </Button>
            </>
          )}
        </Table.Cell>
      </Table.Row>
    );
  });

  return (
    <Container className="tab-item-container">
      <Header as="h4">Targets</Header>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ width: "33.3%" }}>
              Stage
            </Table.HeaderCell>
            <Table.HeaderCell>Value</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{tableRows}</Table.Body>
      </Table>
    </Container>
  );
};

export { Target };
